<div mat-dialog-title class="dialog-header-container">
    <div class="header-content">
        <h2 >{{ title }}</h2>
        <span class="mat-font-body-md">{{description}}</span>
    </div>
</div>
<mat-dialog-content>
    <div class="search-query-section">
        <div class="section-header">
            <mat-icon>{{ searchQueryDisplay.icon }}</mat-icon>
            <span class="query-title">{{ searchQueryDisplay.title }}</span>
        </div>

        <div class="search-query-card">
            <div class="query-info">
                <div class="query-description">{{ searchQueryDisplay.description }}</div>

                <!-- Preview for different search types -->
                <div *ngIf="searchQueryDisplay.preview" class="query-preview">
                    <!-- Image preview for image searches -->
                    <img
                            *ngIf="(searchQueryDisplay.type === 'image-url' || searchQueryDisplay.type === 'image-data') && searchQueryDisplay.preview"
                            [src]="searchQueryDisplay.preview"
                            alt="Search Image"
                            class="preview-image"
                            (error)="$any($event.target).style.display = 'none'" />

                    <!-- Text preview for other types -->
                    <div *ngIf="searchQueryDisplay.type !== 'image-url' && searchQueryDisplay.type !== 'image-data'" class="text-preview">
                        {{ searchQueryDisplay.preview }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Export Configuration Section -->
    <div class="export-config-section">
        <div class="section-header">
            <mat-icon>settings</mat-icon>
            <span>Export Configuration</span>
        </div>

        <!-- Max Records Input -->
        <form [formGroup]="exportForm" class="form-section">
            <mat-form-field appearance="outline" class="max-records-field">
                <mat-label>Maximum Records</mat-label>
                <input matInput type="number" formControlName="maxRecords" [min]="1" [max]="maxAvailableRecords" />
                <mat-hint>Maximum {{ maxAvailableRecords }} records allowed</mat-hint>
                <mat-error *ngIf="exportForm.get('maxRecords')?.errors?.['required']">Number of records is required</mat-error>
                <mat-error *ngIf="exportForm.get('maxRecords')?.errors?.['min']">Must be at least 1 record</mat-error>
                <mat-error *ngIf="exportForm.get('maxRecords')?.errors?.['max']">Maximum {{ maxAvailableRecords }} records allowed</mat-error>
            </mat-form-field>
        </form>
    </div>

    <mat-divider></mat-divider>

    <!-- Export Format Selection -->
    <div class="format-selection-section">
        <div class="section-header">
            <mat-icon>file_download</mat-icon>
            <span>Export Format</span>
        </div>

        <div class="format-cards">
            <mat-card

                    *ngFor="let format of exportFormats"
                    class="format-card"
                    [class.selected]="selectedFormat?.id === format.id"
                    [class.recommended]="format.recommended"
                    (click)="selectFormat(format)">
                <mat-card-content>
                    <div class="format-header">
                        <mat-icon class="format-icon">{{ format.icon }}</mat-icon>
                        <div class="format-info">
                            <div class="format-title">
                                {{ format.label }}
                                <span *ngIf="format.recommended" class="recommended-badge">Recommended</span>
                            </div>
                            <div class="format-extension">.{{ format.fileExtension }}</div>
                        </div>
                    </div>
                    <div class="format-description">{{ format.description }}</div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <!-- Export Progress Section -->
    <div *ngIf="exportProgress.isExporting || exportProgress.completed || hasError" class="progress-section">
        <div class="section-header" [class.warning]="isWarning">
            <mat-icon>{{ hasError ? "error" : isWarning ? "warning" : isCompleted ? "check_circle" : "hourglass_empty" }}</mat-icon>
            <span>Export Progress</span>
        </div>

        <div class="progress-content">
            <!-- Progress Bar -->
            <div *ngIf="exportProgress.isExporting" class="progress-container">
                <mat-progress-bar mode="determinate" [value]="exportProgress.progress"></mat-progress-bar>
                <div class="progress-text">{{ exportProgress.progress }}%</div>
            </div>

            <!-- Status Message -->
            <div class="status-message" [class.error]="hasError" [class.success]="isCompleted && !isWarning" [class.warning]="isWarning">
                <mat-icon>
                    {{ hasError ? "error" : isWarning ? "warning" : isCompleted ? "check_circle" : "info" }}
                </mat-icon>
                <span>{{ exportProgress.statusMessage }}</span>
            </div>
        </div>
    </div>

</mat-dialog-content>
<mat-dialog-actions align="start">
    <button matButton type="button" (click)="onCancel()" [disabled]="exportProgress.isExporting" aria-label="Cancel export">Cancel</button>
    <div class="spacer"></div>
    <!-- Export button - always visible when can export -->
    <button matButton="filled" [disabled]="!canExport" (click)="onExport()" color="primary" aria-label="Start export">
       {{ exportButtonText }}
    </button>
</mat-dialog-actions>
